export default __webpack_public_path__ + "static/media/muscle-building.fe0294c0.png";